export default [
  {
    title: 'Check Top Up Idle',
    customicon: '<span class="k-diagram text-lg mr-[10px] "  />',
    tagVariant: 'light-warning',
    resource: 'OverviewMonitoring',
    route: 'monitoring-check-top-up-idle',
    action: 'manage',
  },
]
